import { useState } from 'react';

import AuthorNameAndSurname from './AuthorNameAndSurname';
import AuthorSearch from './AuthorSearch';

function AuthorNameAndSurnameFieldContainer({ disabled, isEditPage = false }) {
  const [newAuthor, setNewAuthor] = useState(isEditPage);

  function handleNewAuthor(bool) {
    setNewAuthor(bool);
  }

  return newAuthor ? (
    <AuthorNameAndSurname
      disabled={disabled}
      isEditPage={isEditPage}
    />
  ) : (
    <AuthorSearch handleNewAuthor={handleNewAuthor} />
  );
}

export default AuthorNameAndSurnameFieldContainer;
